module.exports = __webpack_public_path__ + "static/media/bucket.13443a3b.svg";